module.exports = __webpack_public_path__ + "images/e6e87a94ec3afd58079e27ee207f916a.png";